import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface ISpeakerVideoPresenter {
  call: Call;
  activeOpponent: Opponent;
  isShowScreenShare: boolean;
  isShowOpponentVideo: boolean;
  hasPreviewOpponents: boolean;
}

export const useSpeakerVideoPresenter = (): ISpeakerVideoPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<ISpeakerVideoPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    get activeOpponent(): Opponent {
      return presenter.call.viewState.speakerOpponent;
    },

    get isShowScreenShare(): boolean {
      return (
        !!presenter.activeOpponent &&
        presenter.activeOpponent.isSharedScreen &&
        !!presenter.activeOpponent.memberDevice?.isMyDevice
      );
    },

    get hasPreviewOpponents(): boolean {
      return presenter.call.viewState.hasPreviewOpponents;
    },

    get isShowOpponentVideo(): boolean {
      return (
        !!presenter.activeOpponent &&
        (!presenter.activeOpponent.isSharedScreen ||
          !presenter.activeOpponent.memberDevice?.isMyDevice)
      );
    },
  }));

  return presenter;
};
